import DropzoneMultiple from './DropzoneMultiple';
export default DropzoneMultiple;
